<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Sesiones Activas</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Sistema</span>
      <span> /</span>
      <span>Sesiones Activas</span>
    </p>
  </div>
</div>

<div class="container-fluid mt-3">
    <div class="card mb-3">
        <div class="card-body">
            <!-- Panel de Filtros -->
            <form [formGroup]="formFiltro" class="mb-4">
                <div class="row">
                    <div class="col-md-5">
                        <div class="md-form">
                            <mdb-select formControlName="rutUsuario" label="Usuarios" [options]="optionUsuarios"
                              placeholder="Usuarios"></mdb-select>
                          </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer d-flex align-items-end" style="border-top: 1px solid #dee2e6">
            <button mdbBtn type="button" color="grey" size="sm" mdbWavesEffect (click)="limpiarFiltros()">Limpiar</button>
            <button mdbBtn type="button" color="grey" size="sm" mdbWavesEffect (click)="buscar()">Buscar</button>
        </div>
    </div>
    <div class="card">
        <div class="card-body">
            <!-- Tabla de Bloqueos -->
            <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col">Rut Usuario</th>
                            <th scope="col">Nombre Usuario</th>
                            <th scope="col">Fecha Utima Actividad</th>
                            <th scope="col">Fecha Expiración</th>
                            <th scope="col">Navegador</th>
                            <th scope="col">Sistema Operativo</th>
                            <th scope="col">Dispositivo</th>
                            <th scope="col">IP</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="sesionesActivas.length === 0">
                            <td colspan="9" class="text-center">No hay sesiones activas que coincidan con los filtros.</td>
                        </tr>
                        <tr *ngFor="let sesion of sesionesActivas">
                            <td>{{ sesion.rutFormato }}</td>
                            <td>{{ sesion.nombreUsuario }}</td>
                            <td>{{ sesion.fecha_ultima_actividad | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                            <td>{{ sesion.fecha_expiracion | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                            <td>{{ sesion.navegador }}</td>
                            <td>{{ sesion.sistemaOperativo }}</td>
                            <td>{{ sesion.tipoDispositivo }}</td>
                            <td>{{ sesion.ip_address }}</td>
                            <td>
                                <button mdbBtn type="button" color="danger" size="sm" mdbWavesEffect (click)="validarEliminar(sesion)">
                                    <mdb-icon fas icon="trash-alt" class="mr-1"></mdb-icon> Eliminar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>